import { useRouter } from 'next/router';
import { useRef } from 'react';
import styles from './index.module.scss';
import { cardMap } from '@/data/ecocreditsday';
import { createEFPic } from '@/utils/useEFPic';
import { useLang } from '@/i18n';

const { EFPic } = createEFPic('/media/ecocredits-day/pc/');

export default function CardList() {
    const { locale } = useRouter();
    const { t } = useLang('ecocreditsday.pageTabs.tabB.cardList');
    const cardData = cardMap[locale as keyof typeof cardMap] || cardMap.jp;
    const cardRef = useRef<HTMLDivElement | null>(null);

    const cardScroll = (x = 0) => {
        cardRef.current?.scrollTo({ left: x, behavior: 'smooth' });
    };

    return (
        <div className={styles.cardList}>
            {['kr'].includes(locale as string) && <div className="title">{t('title')}</div>}
            <div className="card-list">
                {cardData.length >= 4 && <div className="swiper-button swiper-button__prev" onClick={() => cardScroll(0)}></div>}
                <div className="card-list__box" ref={cardRef}>
                    {cardData.map((item: Record<string, string | string[]>, index) => (
                        <div className={`card-item ${index === cardData.length - 1 ? 'last-item' : ''}`} key={index}>
                            <EFPic className="card-img" name={item.src} />
                            <div className="card-item__text">{item.text}</div>
                        </div>
                    ))}
                </div>
                {cardData.length >= 4 && <div className="swiper-button swiper-button__next" onClick={() => cardScroll(1000)}></div>}
            </div>
        </div>
    );
}
